import { Component, Inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FeedbackService, FeedbackStyle, FeedbackTitle } from '@services/feedback';
import { ProgressIndicatorService } from '@services/progress';

import { I18nService } from '../../../../../../i18n/services';
import { UsersService } from '../../../../../../services/users';
import { FormEditorInputType } from '../../../../../../shared/components';
import { ITermsAcceptDialogData } from './users-terms-accept.models';

@Component({
	selector: 'app-users-terms-accept',
	templateUrl: './users-terms-accept.dialog.html'
})
export class UsersTermsAcceptDialogComponent {
	public formEditorInputType = FormEditorInputType;
	public formInputs = this.formBuilder.group({
		id: ['', [Validators.required]]
	});

	constructor(
		private feedbackService: FeedbackService,
		public usersService: UsersService,
		private progressIndicatorService: ProgressIndicatorService,
		@Inject(MAT_DIALOG_DATA) public dialogData: ITermsAcceptDialogData,
		private dialogRef: MatDialogRef<UsersTermsAcceptDialogComponent>,
		private formBuilder: FormBuilder,
		private i18nService: I18nService
	) {}

	public confirmAcceptTerm(): void {
		this.feedbackService.confirm({
			title: FeedbackTitle.warning,
			message: this.i18nService.get(
				'Accepting terms on behalf of a user circumvents any protection that would otherwise force a user to accept terms and conditions. Are you sure you want to continue?',
				'app.prompt.users.confirm-accept-user-terms'
			),
			style: FeedbackStyle.error,
			callback: (confirmed: boolean) => {
				if (confirmed) this.acceptTerm();
			}
		});
	}

	private acceptTerm(): void {
		this.progressIndicatorService.spinner(true);

		this.usersService
			.acceptTerm(this.dialogData.user.identities['COGNITO'], this.dialogData.clusterId, this.formInputs.value.id)
			.subscribe(
				(res: boolean) => {
					if (res) {
						this.feedbackService.notification({
							msg: this.i18nService.get('Terms successfully accepted.', 'app.prompt.users.accepted-user-terms')
						});

						this.dialogData.callback(true);
						this.dialogRef.close();
					} else {
						this.progressIndicatorService.spinner(false);
						this.feedbackService.apiError(
							null,
							this.i18nService.get(
								'Failed to accept terms on behalf of the user.',
								'app.prompt.users.failed-accept-user-terms'
							)
						);
					}
				},
				(error: any) => {
					this.progressIndicatorService.spinner(false);
					this.feedbackService.apiError(error);
				}
			);
	}
}
